import Small from 'UIComponents/elements/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import RefreshButton from './RefreshButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CopilotPreviewHeader = ({
  numHoursTilSummaryStale,
  timestamp,
  onRefresh,
  previewTitle
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(RefreshButton, {
      timestamp: timestamp,
      threshold: numHoursTilSummaryStale,
      onRefresh: onRefresh
    }), /*#__PURE__*/_jsx(Small, {
      tagName: "div",
      weight: "medium",
      children: previewTitle || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "aiAddonCopilotPreview.components.copilotPreview.summaryTitle"
      })
    })]
  });
};
export default CopilotPreviewHeader;